import React, { forwardRef } from 'react';

const IcNegative = forwardRef(
  (properties, ref) => /* @__PURE__ */ React.createElement("svg", {
    fill: "none",
    height: "24",
    ref,
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    ...properties
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M10.7403 2.48484C11.5187 2.03077 12.4813 2.03077 13.2597 2.48484L19.7597 6.27651C20.5277 6.72453 21 7.54679 21 8.43595V15.5641C21 16.4533 20.5277 17.2755 19.7597 17.7235L13.2597 21.5152C12.4813 21.9693 11.5187 21.9693 10.7403 21.5152L4.24032 17.7235C3.47228 17.2755 3 16.4533 3 15.5641V8.43595C3 7.54679 3.47228 6.72453 4.24032 6.27651L10.7403 2.48484Z",
    fill: "var(--negative-icon-default)"
  }), /* @__PURE__ */ React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 12.5L11 8.25C11 7.69772 11.4477 7.25 12 7.25C12.5523 7.25 13 7.69772 13 8.25L13 12.5C13 13.0523 12.5523 13.5 12 13.5C11.4477 13.5 11 13.0523 11 12.5Z",
    fill: "var(--negative-icon-in-default)",
    fillRule: "evenodd"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: "12",
    cy: "16",
    fill: "white",
    r: "1.25"
  }))
);

export { IcNegative };
//# sourceMappingURL=ic-negative.js.map
